/**
 * Client-safe analytics API. Do not add server-only exports here (avoids bundling posthog-node).
 */
export { AnalyticsEvent, type AnalyticsEventName } from "./analytics-events";
export { captureClientException, identifyAnalyticsUser, resetAnalyticsUser, trackClientEvent } from "./event-manager";
